import React, { CSSProperties } from 'react';
import styles from './OptionsList.module.css';
import SearchInput from '../../../SearchInput/SearchInput';
import List from '../../../../DataDisplay/List/List';
import { SelectBoxOption } from '../../SelectBox.types.';

export type ListItemProps<T extends SelectBoxOption> = {
    item: T | undefined;
    style: CSSProperties;
    loading?: boolean;
};

export type OptionsListProps<T extends SelectBoxOption> = {
    searchable?: boolean;
    searchQuery?: string;
    setSearchQuery?: (searchQuery: string) => void;
    searchPlaceholder?: string;
    options: T[];
    count: number;
    noOptionsLabel?: string;
    children: (props: ListItemProps<T>) => React.ReactNode;
    loading?: boolean;
    loadMore?: () => Promise<void>;
};

const OptionsList = <T extends SelectBoxOption>({
    options,
    count,
    searchQuery,
    setSearchQuery,
    searchable,
    noOptionsLabel = 'No options',
    children,
    loading,
    loadMore,
    searchPlaceholder,
}: OptionsListProps<T>) => {
    const handleSearchQueryChange = (query: string) => {
        if (typeof setSearchQuery === 'function') {
            setSearchQuery(query);
        }
    };

    return (
        <div>
            {searchable && (
                <SearchInput
                    className={styles.searchInput}
                    value={searchQuery}
                    onChange={handleSearchQueryChange}
                    placeholder={searchPlaceholder}
                />
            )}
            <div className={styles.list} style={{ height: count * 70 }}>
                {!options.length && <span className={styles.noOptionsLabel}>{noOptionsLabel}</span>}
                {options.length > 0 && (
                    <List loading={loading} data={options} rowCount={count} loadMoreRows={loadMore}>
                        {({ item, style, loading }) => {
                            if (!item && !loading) {
                                return <div style={style}></div>;
                            }

                            return children({ loading, item, style });
                        }}
                    </List>
                )}
            </div>
        </div>
    );
};

export default OptionsList;
